import { render, staticRenderFns } from "./CurrentDisciplinesSpecialities.vue?vue&type=template&id=42ca6909&"
import script from "./CurrentDisciplinesSpecialities.vue?vue&type=script&lang=ts&"
export * from "./CurrentDisciplinesSpecialities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports